import * as Sentry from '@sentry/nextjs';

type CaptureException = (
  error: unknown,
  captureContext?: unknown
) => string | undefined;

const sentryModule = Sentry as unknown as {
  captureException?: CaptureException;
  default?: {
    captureException?: CaptureException;
  };
};

export const captureException: CaptureException = (error, captureContext) => {
  const sentryCaptureException =
    sentryModule.captureException ?? sentryModule.default?.captureException;

  if (typeof sentryCaptureException !== 'function') {
    // Keep local error handling from throwing when Sentry's export shape changes.
    console.error(error);
    return undefined;
  }

  return sentryCaptureException(error, captureContext);
};
